import { createSelector, Dispatch } from '@reduxjs/toolkit';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesViewAllReviewsClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesViewAllReviewsClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { navigateToHashWithTabBarOffset } from 'component/common/DetailInViewWrapper/navigateToHashWithTabBarOffset';
import { setIsScrolling } from 'component/page/detail/store/details';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { selectActivityIdFromBootstrap, selectCmsFromBootstrap } from 'store/slice/bootstrap';

interface StateProps {
    cms: CmsValue;
    activityId: number;
}

interface ReviewSectionProps {
    reviewSectionHref: string;
}

export type RecentReviewsProps = StateProps & ReviewSectionProps & RecentReviewsDispatchProps;

interface RecentReviewsDispatchProps {
    onAllReviewClick: (seeReviewHref: string) => void;
}

export const mapStateToProps = createSelector(selectCmsFromBootstrap, selectActivityIdFromBootstrap, (cms, activityId): StateProps => {
    return { cms, activityId };
});

export const mapDispatchToRecentReviewsProps = (dispatch: Dispatch): RecentReviewsDispatchProps => ({
    onAllReviewClick: (seeReviewHref: string) => {
        trackElementEvent<ActivitiesViewAllReviewsClickEventActivitiesFieldsV1>(ActivitiesViewAllReviewsClickEventActivitiesManifestV1.ids, {});
        navigateToHashWithTabBarOffset(dispatch, `#${seeReviewHref}`, setIsScrolling, true);
    },
});
